export const ARTICLES = [
  {
    slug: "future-of-global-petrochemical-trade",
    category: "Petrochemicals",
    date: "Dec 2025",
    title: "The Future of Global Petrochemical Trade",
    excerpt:
      "Shifting demand centres, refining capacity additions in Asia and MENA, and the rise of specialty chemicals are reshaping global petrochemical flows. What buyers and suppliers should prepare for.",
    image:
      "https://images.pexels.com/photos/162568/oil-pump-jack-sunset-clouds-silhouette-162568.jpeg?auto=compress&cs=tinysrgb&w=1600",
    body: [
      "Global petrochemical trade is entering a new phase. Demand growth is no longer concentrated in a single region — Asia continues to absorb a major share of production while the Middle East adds refining and cracker capacity at an unprecedented pace.",
      "For buyers, this means more route options and competitive pricing. For suppliers, reliability and documentation discipline are becoming the real differentiators. Specialty chemicals, lubricants, and base oils are likely to outperform commodity volumes in the medium term.",
      "At Subterra Nexus, we focus on building corridors that minimize execution risk: verified counterparties, clean documentation, and tight logistics windows."
    ],
  },
  {
    slug: "why-reliable-sourcing-matters",
    category: "Trade Practice",
    date: "Dec 2025",
    title: "Why Reliable Sourcing Matters",
    excerpt:
      "Price is visible; reliability is not. Why long-term trading partnerships outperform one-off deals, and how disciplined sourcing protects margins and reputations on both sides of the trade.",
    image:
      "https://images.pexels.com/photos/14020705/pexels-photo-14020705.jpeg?auto=compress&cs=tinysrgb&w=1600",
    body: [
      "Reliability is the hidden variable in commodity trading. A cheaper cargo that arrives late, short, or off-spec is not cheaper — it is more expensive in every dimension that matters: operations, finance, and reputation.",
      "Disciplined sourcing starts with supplier verification, spec alignment, and clean documentation. It continues through loading, shipping, and delivery with a single accountable trade desk.",
      "Our approach is simple: over-communicate, over-document, and make execution invisible to the buyer."
    ],
  },
  {
    slug: "emerging-trade-corridors-asia-mena-latam",
    category: "Markets",
    date: "Nov 2025",
    title: "Emerging Trade Corridors: Asia, MENA, LATAM",
    excerpt:
      "New corridors are forming as LATAM producers connect with MENA refiners and Asian manufacturers. A look at where the flows are accelerating and what it means for commodity buyers in 2026.",
    image:
      "https://images.pexels.com/photos/3338019/pexels-photo-3338019.jpeg?auto=compress&cs=tinysrgb&w=1600",
    body: [
      "The fastest-growing corridors in global trade are no longer the traditional transatlantic ones. LATAM-to-MENA, Asia-to-LATAM, and India-to-Africa routes are expanding as producers and buyers diversify counterparties.",
      "This creates new opportunities in food commodities, metals, and minerals — but it also raises the bar for logistics coordination, currency handling, and documentation.",
      "A well-run trade desk can turn these corridors into a competitive advantage."
    ],
  },
  {
    slug: "building-trust-in-commodity-trading",
    category: "Leadership",
    date: "Nov 2025",
    title: "Building Trust in Commodity Trading",
    excerpt:
      "Trust in commodity trading is built transaction by transaction. A practical framework for counterparties on both sides — from KYC to post-delivery reporting — that compounds over years.",
    image:
      "https://images.pexels.com/photos/3182812/pexels-photo-3182812.jpeg?auto=compress&cs=tinysrgb&w=1600",
    body: [
      "Trust in trading does not come from marketing. It comes from a track record of on-time, on-spec, on-document delivery — repeated over years.",
      "Our playbook: rigorous onboarding, transparent pricing, structured contracts, disciplined execution, and honest post-delivery reporting.",
      "The result is a counterparty that both buyers and suppliers want to keep trading with."
    ],
  },
];
